<button [id]="buttonId" [type]="buttonType" [class]="'smart-button ' + buttonClasses" [disabled]="disableButton || disableOnLoading" [hidden]="hideOnLoading">
  <span>
    <span [ngClass]="{'invisible': showSpinner && disableOnLoading}"><ng-content></ng-content></span>
    @if (showSpinner && disableOnLoading) {
      <i class="fa fa-refresh fa-spin btn_loader"></i>
    }
  </span>
</button>
